// src/index.ts
import { Placeholder } from "@tiptap/extensions";
import { Placeholder as Placeholder2 } from "@tiptap/extensions";
var index_default = Placeholder;
export {
  Placeholder2 as Placeholder,
  index_default as default
};
//# sourceMappingURL=index.js.map